export const OuterURL = {
  companyURL: "https://libera-inc.com",
  qaURL: "https://liberaworks.zendesk.com/hc/ja",
  termURL:
    "https://storage.googleapis.com/term-storage/%E5%80%8B%E4%BA%BA%E7%99%BB%E9%8C%B2%E8%80%85%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84",
  clientTermURL:
    "https://storage.googleapis.com/term-storage/%E6%B3%95%E4%BA%BA%E7%99%BB%E9%8C%B2%E8%80%85%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84",
  privacyURL:
    "https://storage.googleapis.com/term-storage/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC",
  customerFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/categories/360001374912-",
  clientFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/categories/360001368432-",
  employmentURL: "https://libera-inc.com/Recruit",
  liberaForProURL: "https://top-talent.io/",
  liberaForClientURL: "https://top-talent.io/client",
  calendlyURL: "https://calendly.com/expert-network/60min",
  contractURL: "https://expert-network.io/contracts.html",
  customerProjectFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360024017632-",
  customerMessageFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360042487011-",
  customerMypageFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360024276511-",
  customerClientBlockFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360042618352-",
  customerContractFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360049127532-",
  customerActivityFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360049606111-",
  customerInvoiceFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360049605931-",
  clientScoutFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360022170591-",
  clientMessageFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360022986512-",
  clientProjectFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360023230771-",
  clientMemberFaqURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360042010531-",
  afterEntryQaURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360024017632-",
  clientBlockQaURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360042618352-",
  noContractQaURL:
    "https://liberaworks.zendesk.com/hc/ja/articles/360045446652-",
  planChangeFormURL: "https://form.run/@service-register-1632813842",
};



// WEBPACK FOOTER //
// ./src/config/view_const/outer_url.ts